"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
/**
* @export
* @enum {string}
*/
var MembershipStatusEnum;
(function (MembershipStatusEnum) {
    MembershipStatusEnum["Active"] = "active";
    MembershipStatusEnum["NeedsDdMandate"] = "needs_dd_mandate";
    MembershipStatusEnum["NeedsAttention"] = "needs_attention";
    MembershipStatusEnum["Reserved"] = "reserved";
    MembershipStatusEnum["Inactive"] = "inactive";
    MembershipStatusEnum["Expired"] = "expired";
    MembershipStatusEnum["Upcoming"] = "upcoming";
})(MembershipStatusEnum = exports.MembershipStatusEnum || (exports.MembershipStatusEnum = {})); /**
* @export
* @enum {string}
*/
var MembershipSourceEnum;
(function (MembershipSourceEnum) {
    MembershipSourceEnum["SelfSignup"] = "self_signup";
    MembershipSourceEnum["App"] = "app";
    MembershipSourceEnum["Import"] = "import";
    MembershipSourceEnum["Unknown"] = "unknown";
})(MembershipSourceEnum = exports.MembershipSourceEnum || (exports.MembershipSourceEnum = {})); /**
* @export
* @enum {string}
*/
var MembershipAttentionReasonEnum;
(function (MembershipAttentionReasonEnum) {
    MembershipAttentionReasonEnum["NoMandate"] = "no_mandate";
    MembershipAttentionReasonEnum["SetupUnpaid"] = "setup_unpaid";
    MembershipAttentionReasonEnum["MandateRevoked"] = "mandate_revoked";
    MembershipAttentionReasonEnum["PaymentFailed"] = "payment_failed";
    MembershipAttentionReasonEnum["PaymentDisputed"] = "payment_disputed";
    MembershipAttentionReasonEnum["PaymentOutstanding"] = "payment_outstanding";
    MembershipAttentionReasonEnum["SiteId"] = "site_id";
})(MembershipAttentionReasonEnum = exports.MembershipAttentionReasonEnum || (exports.MembershipAttentionReasonEnum = {}));
function MembershipFromJSON(json) {
    return MembershipFromJSONTyped(json, false);
}
exports.MembershipFromJSON = MembershipFromJSON;
function MembershipFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'site_id': !runtime_1.exists(json, 'site_id') ? undefined : json['site_id'],
        'membership_number': !runtime_1.exists(json, 'membership_number') ? undefined : json['membership_number'],
        'customer': !runtime_1.exists(json, 'customer') ? undefined : _1.CustomerFromJSON(json['customer']),
        'members': !runtime_1.exists(json, 'members') ? undefined : (json['members'].map(_1.MemberSummaryFromJSON)),
        'type': !runtime_1.exists(json, 'type') ? undefined : _1.MembershipTypeFromJSON(json['type']),
        'rate': !runtime_1.exists(json, 'rate') ? undefined : _1.MembershipRateFromJSON(json['rate']),
        'status': !runtime_1.exists(json, 'status') ? undefined : json['status'],
        'source': !runtime_1.exists(json, 'source') ? undefined : json['source'],
        'payment_method': !runtime_1.exists(json, 'payment_method') ? undefined : _1.PaymentMethodFromJSON(json['payment_method']),
        'start_date': !runtime_1.exists(json, 'start_date') ? undefined : (new Date(json['start_date'])),
        'end_date': !runtime_1.exists(json, 'end_date') ? undefined : (new Date(json['end_date'])),
        'created_at': !runtime_1.exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'basket_id': !runtime_1.exists(json, 'basket_id') ? undefined : json['basket_id'],
        'external_ref': !runtime_1.exists(json, 'external_ref') ? undefined : json['external_ref'],
        'next_billing_date': !runtime_1.exists(json, 'next_billing_date') ? undefined : (new Date(json['next_billing_date'])),
        'next_charge': !runtime_1.exists(json, 'next_charge') ? undefined : _1.ChargeSummaryFromJSON(json['next_charge']),
        'attention_reason': !runtime_1.exists(json, 'attention_reason') ? undefined : json['attention_reason'],
    };
}
exports.MembershipFromJSONTyped = MembershipFromJSONTyped;
function MembershipToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'site_id': value.site_id,
        'membership_number': value.membership_number,
        'customer': _1.CustomerToJSON(value.customer),
        'members': value.members === undefined ? undefined : (value.members.map(_1.MemberSummaryToJSON)),
        'type': _1.MembershipTypeToJSON(value.type),
        'rate': _1.MembershipRateToJSON(value.rate),
        'status': value.status,
        'source': value.source,
        'payment_method': _1.PaymentMethodToJSON(value.payment_method),
        'start_date': value.start_date === undefined ? undefined : (value.start_date.toISOString()),
        'end_date': value.end_date === undefined ? undefined : (value.end_date.toISOString()),
        'created_at': value.created_at === undefined ? undefined : (value.created_at.toISOString()),
        'basket_id': value.basket_id,
        'external_ref': value.external_ref,
        'next_billing_date': value.next_billing_date === undefined ? undefined : (value.next_billing_date.toISOString()),
        'next_charge': _1.ChargeSummaryToJSON(value.next_charge),
        'attention_reason': value.attention_reason,
    };
}
exports.MembershipToJSON = MembershipToJSON;
